import React from "react";
import styles from "./styles.css";
// import Temperaturechecks from "../../shared/images/covid-assets/temperature-checks.png";
import Arogyasetuapp from "../../shared/images/covid-assets/arogya-setu-app.png";
import Protectivegear from "../../shared/images/covid-assets/protective-gear.png";
import Carsanitization from "../../shared/images/covid-assets/car-sanitization.png";
import Socialdistancing from "../../shared/images/covid-assets/social-distancing.png";
// import Customersafetykit from "../../shared/images/covid-assets/customer-safety-kit.png";
import CustomerSafetyCard from "../customer-safe-card";

const OurSafeCustomer = () => {

    const cardData = [
        // {
        //     heading: "Daily Temperature Checks",
        //     text: "Staff at Cars24 undergo mandatory temperature screening before " +
        //     "entering and exiting offices every day. The customers visiting our" +
        //     " branches are also screened for body temperature.",
        //     image: Temperaturechecks
        // },
        {
            heading: "Aarogya Setu App to Monitor Health",
            text: "We’ve mandated the usage of the Aarogya Setu app to monitor the " +
            "health status of our employees on a daily basis. ",
            image: Arogyasetuapp
        },
        {
            heading: "Protective Gear for Staff",
            text: "Cars24 employees are mandated to wear personal protective gear " +
            "including mask and gloves throughout the car selling process",
            image: Protectivegear
        },
        {
            heading: "Car Sanitization &  Disinfection",
            text: "Safe sanitization and disinfection of exterior and interior, usage" +
            " of disposable cover for seats, steering, gear knob and handbrake for all " +
            "cars to ensure maximum safety. ",
            image: Carsanitization
        },
        {
            heading: "Social Distancing & Hygiene Trained",
            text: "All our employees have undergone training on social distancing and hygiene " +
            "practices as per WHO guidelines, maintaining 1 meter or more distance, minimal " +
            "customer interaction throughout the process.",
            image: Socialdistancing

        }
        // {
        //     heading: "Customer Safety Kit",
        //     text: "To ensure safety, our customers are provided with sanitizers, alcohol wipes, " +
        //     "and safety masks at all Cars24 branches.",
        //     image: Customersafetykit

        // }
    ];

    const renderCards = () => {
        return cardData.map((data, index) => (

            <div className={"col-6"} styleName={"styles.safeCustomerBox"} key={index}>
                <CustomerSafetyCard
                    {...data}
                />
            </div>

        ));
    };

    return (
        <section styleName={"styles.keepCustomerSafe"}>
            <div className={"container"}>
                <h3>We are committed to keeping our customer safe!</h3>
                <div className={"row"}>
                    {renderCards()}
                </div>
            </div>
        </section>
    );
};

export default OurSafeCustomer;
